import { createContext, useContext } from 'react';

export type LayoutApi = {
  activeSection: string | null;
  setActiveSection: (id: string | null) => void;
  jumpTo: (id: string) => void;
  /** Back to the top of the page, with no section active — a fresh start (New). */
  scrollToTop: () => void;
  railCollapsed: boolean;
  toggleRail: () => void;
  /** The left sidebar held open (labels showing, page pushed over) rather than
   *  only widening over the page on hover / keyboard focus. */
  spinePinned: boolean;
  toggleSpinePin: () => void;
  overlay: string | null;
  openOverlay: (id: string) => void;
  closeOverlay: () => void;
};

export const LayoutCtx = createContext<LayoutApi | null>(null);

/** The shell's service (guidelines §2): features call this, never the shell's DOM. */
export function useLayout(): LayoutApi {
  const v = useContext(LayoutCtx);
  if (!v) throw new Error('useLayout must be used inside <LayoutProvider>.');
  return v;
}
